var v = "5.12.1";
var fr = 24;
var ip = 0;
var op = 42;
var w = 360;
var h = 360;
var nm = "04_with text_json";
var ddd = 0;
var assets = [
];
var fonts = {
	list: [
		{
			fName: "Roobert-SemiBold",
			fFamily: "Roobert",
			fStyle: "SemiBold",
			ascent: 71.9985961914062
		}
	]
};
var layers = [
	{
		ddd: 0,
		ind: 1,
		ty: 5,
		nm: "LOADING",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					180,
					344.085,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					0.475,
					-12.689,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		t: {
			d: {
				k: [
					{
						s: {
							s: 36,
							f: "Roobert-SemiBold",
							t: "LOADING",
							ca: 0,
							j: 2,
							tr: 0,
							lh: 25.6000003814697,
							ls: 0,
							fc: [
								1,
								1,
								1
							]
						},
						t: 0
					},
					{
						s: {
							s: 36,
							f: "Roobert-SemiBold",
							t: "LOADING.",
							ca: 0,
							j: 2,
							tr: 0,
							lh: 25.6000003814697,
							ls: 0,
							fc: [
								1,
								1,
								1
							]
						},
						t: 10
					},
					{
						s: {
							s: 36,
							f: "Roobert-SemiBold",
							t: "LOADING..",
							ca: 0,
							j: 2,
							tr: 0,
							lh: 25.6000003814697,
							ls: 0,
							fc: [
								1,
								1,
								1
							]
						},
						t: 20
					},
					{
						s: {
							s: 36,
							f: "Roobert-SemiBold",
							t: "LOADING...",
							ca: 0,
							j: 2,
							tr: 0,
							lh: 25.6000003814697,
							ls: 0,
							fc: [
								1,
								1,
								1
							]
						},
						t: 30
					}
				]
			},
			p: {
			},
			m: {
				g: 1,
				a: {
					a: 0,
					k: [
						0,
						0
					],
					ix: 2
				}
			},
			a: [
			]
		},
		ip: 0,
		op: 42,
		st: 0,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 3,
		ty: 4,
		nm: "middle matte end",
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					178.5,
					179.5,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-1.5,
					-0.5,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-44.75,
										-0.5
									],
									[
										44.75,
										-0.5
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.023529413635,
								0.086274509804,
								0.098039223166,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 26,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.2
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.2
								],
								y: [
									0
								]
							},
							t: 19,
							s: [
								25
							]
						},
						{
							t: 29,
							s: [
								83
							]
						}
					],
					ix: 1
				},
				e: {
					a: 0,
					k: 0,
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 19,
		op: 42,
		st: -2,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 4,
		ty: 4,
		nm: "middle 2",
		tt: 1,
		tp: 3,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					180,
					179.5,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-0.5,
					-0.5,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										44.25,
										-12.5
									],
									[
										44.25,
										12.5
									],
									[
										19.5,
										12.5
									],
									[
										-0.25,
										1.25
									],
									[
										-20.75,
										12.5
									],
									[
										-45,
										12.5
									],
									[
										-45,
										-12.5
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-0.5,
								-0.5
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Rectangle 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 19,
		op: 42,
		st: 0,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 5,
		ty: 4,
		nm: "middle matte start",
		td: 1,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					178.5,
					179.5,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-1.5,
					-0.5,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										-44.75,
										-0.5
									],
									[
										44.75,
										-0.5
									]
								],
								c: false
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0.023529413635,
								0.086274509804,
								0.098039223166,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 26,
							ix: 5
						},
						lc: 1,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Shape 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.34
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.66
								],
								y: [
									0
								]
							},
							t: 0,
							s: [
								25
							]
						},
						{
							t: 10,
							s: [
								100
							]
						}
					],
					ix: 1
				},
				e: {
					a: 0,
					k: 100,
					ix: 2
				},
				o: {
					a: 0,
					k: 0,
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 11,
		st: 0,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 6,
		ty: 4,
		nm: "middle 1",
		tt: 1,
		tp: 5,
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					180,
					179.5,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-0.5,
					-0.5,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ind: 0,
						ty: "sh",
						ix: 1,
						ks: {
							a: 0,
							k: {
								i: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								o: [
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									],
									[
										0,
										0
									]
								],
								v: [
									[
										44.25,
										-12.5
									],
									[
										44.25,
										12.5
									],
									[
										19.5,
										12.5
									],
									[
										-0.25,
										1.25
									],
									[
										-20.75,
										12.5
									],
									[
										-45,
										12.5
									],
									[
										-45,
										-12.5
									]
								],
								c: true
							},
							ix: 2
						},
						nm: "Path 1",
						mn: "ADBE Vector Shape - Group",
						hd: false
					},
					{
						ty: "fl",
						c: {
							a: 0,
							k: [
								0,
								1,
								1,
								1
							],
							ix: 4
						},
						o: {
							a: 0,
							k: 100,
							ix: 5
						},
						r: 1,
						bm: 0,
						nm: "Fill 1",
						mn: "ADBE Vector Graphic - Fill",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-0.5,
								-0.5
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Rectangle 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			}
		],
		ip: 0,
		op: 11,
		st: 0,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 7,
		ty: 4,
		nm: "left",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					179,
					180,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-2,
					0.5,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "rc",
						d: 1,
						s: {
							a: 0,
							k: [
								64,
								90
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 4
						},
						nm: "Rectangle Path 1",
						mn: "ADBE Vector Shape - Rect",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 26,
							ix: 5
						},
						lc: 3,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-2,
								0.5
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Rectangle 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 50,
					ix: 1
				},
				e: {
					a: 0,
					k: 79,
					ix: 2
				},
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.4
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.6
								],
								y: [
									0
								]
							},
							t: 2,
							s: [
								1
							]
						},
						{
							t: 26,
							s: [
								-359
							]
						}
					],
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 42,
		st: 0,
		ct: 1,
		bm: 0
	},
	{
		ddd: 0,
		ind: 8,
		ty: 4,
		nm: "right",
		sr: 1,
		ks: {
			o: {
				a: 0,
				k: 100,
				ix: 11
			},
			r: {
				a: 0,
				k: 0,
				ix: 10
			},
			p: {
				a: 0,
				k: [
					180,
					180,
					0
				],
				ix: 2,
				l: 2
			},
			a: {
				a: 0,
				k: [
					-2,
					0.5,
					0
				],
				ix: 1,
				l: 2
			},
			s: {
				a: 0,
				k: [
					100,
					100,
					100
				],
				ix: 6,
				l: 2
			}
		},
		ao: 0,
		shapes: [
			{
				ty: "gr",
				it: [
					{
						ty: "rc",
						d: 1,
						s: {
							a: 0,
							k: [
								64,
								90
							],
							ix: 2
						},
						p: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 4
						},
						nm: "Rectangle Path 1",
						mn: "ADBE Vector Shape - Rect",
						hd: false
					},
					{
						ty: "st",
						c: {
							a: 0,
							k: [
								0,
								1,
								1,
								1
							],
							ix: 3
						},
						o: {
							a: 0,
							k: 100,
							ix: 4
						},
						w: {
							a: 0,
							k: 26,
							ix: 5
						},
						lc: 3,
						lj: 1,
						ml: 4,
						bm: 0,
						nm: "Stroke 1",
						mn: "ADBE Vector Graphic - Stroke",
						hd: false
					},
					{
						ty: "tr",
						p: {
							a: 0,
							k: [
								-2,
								0.5
							],
							ix: 2
						},
						a: {
							a: 0,
							k: [
								0,
								0
							],
							ix: 1
						},
						s: {
							a: 0,
							k: [
								100,
								100
							],
							ix: 3
						},
						r: {
							a: 0,
							k: 0,
							ix: 6
						},
						o: {
							a: 0,
							k: 100,
							ix: 7
						},
						sk: {
							a: 0,
							k: 0,
							ix: 4
						},
						sa: {
							a: 0,
							k: 0,
							ix: 5
						},
						nm: "Transform"
					}
				],
				nm: "Rectangle 1",
				np: 3,
				cix: 2,
				bm: 0,
				ix: 1,
				mn: "ADBE Vector Group",
				hd: false
			},
			{
				ty: "tm",
				s: {
					a: 0,
					k: 0,
					ix: 1
				},
				e: {
					a: 0,
					k: 29.2,
					ix: 2
				},
				o: {
					a: 1,
					k: [
						{
							i: {
								x: [
									0.4
								],
								y: [
									1
								]
							},
							o: {
								x: [
									0.6
								],
								y: [
									0
								]
							},
							t: 2,
							s: [
								0
							]
						},
						{
							t: 26,
							s: [
								-360
							]
						}
					],
					ix: 3
				},
				m: 1,
				ix: 2,
				nm: "Trim Paths 1",
				mn: "ADBE Vector Filter - Trim",
				hd: false
			}
		],
		ip: 0,
		op: 42,
		st: 0,
		ct: 1,
		bm: 0
	}
];
var markers = [
];
var props = {
};
var chars = [
	{
		ch: "L",
		size: 36,
		style: "SemiBold",
		w: 53.9,
		data: {
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											6.747,
											0
										],
										[
											53.073,
											0
										],
										[
											53.073,
											-11.581
										],
										[
											20.142,
											-11.581
										],
										[
											20.142,
											-70.496
										],
										[
											6.747,
											-70.496
										]
									],
									c: true
								},
								ix: 2
							},
							nm: "L",
							mn: "ADBE Vector Shape - Group",
							hd: false
						}
					],
					nm: "L",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: false
				}
			]
		},
		fFamily: "Roobert"
	},
	{
		ch: "O",
		size: 36,
		style: "SemiBold",
		w: 77.9,
		data: {
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[
											-20.544,
											0
										],
										[
											0,
											20.746
										],
										[
											20.444,
											0
										],
										[
											0,
											-20.746
										]
									],
									o: [
										[
											20.444,
											0
										],
										[
											0,
											-20.746
										],
										[
											-20.544,
											0
										],
										[
											0,
											20.746
										]
									],
									v: [
										[
											39.276,
											0.806
										],
										[
											74.826,
											-35.248
										],
										[
											39.276,
											-71.301
										],
										[
											3.625,
											-35.248
										]
									],
									c: true
								},
								ix: 2
							},
							nm: "O",
							mn: "ADBE Vector Shape - Group",
							hd: false
						},
						{
							ind: 1,
							ty: "sh",
							ix: 2,
							ks: {
								a: 0,
								k: {
									i: [
										[
											12.891,
											0
										],
										[
											0,
											14.099
										],
										[
											-12.79,
											0
										],
										[
											0,
											-14.099
										]
									],
									o: [
										[
											-12.79,
											0
										],
										[
											0,
											-14.099
										],
										[
											12.891,
											0
										],
										[
											0,
											14.099
										]
									],
									v: [
										[
											39.175,
											-10.776
										],
										[
											17.02,
											-35.248
										],
										[
											39.175,
											-59.821
										],
										[
											61.432,
											-35.248
										]
									],
									c: true
								},
								ix: 2
							},
							nm: "O",
							mn: "ADBE Vector Shape - Group",
							hd: false
						}
					],
					nm: "O",
					np: 5,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: false
				}
			]
		},
		fFamily: "Roobert"
	},
	{
		ch: "A",
		size: 36,
		style: "SemiBold",
		w: 67.5,
		data: {
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											53.577,
											0
										],
										[
											67.374,
											0
										],
										[
											40.182,
											-70.496
										],
										[
											27.695,
											-70.496
										],
										[
											0.604,
											0
										],
										[
											14.301,
											0
										],
										[
											20.343,
											-16.415
										],
										[
											47.534,
											-16.415
										]
									],
									c: true
								},
								ix: 2
							},
							nm: "A",
							mn: "ADBE Vector Shape - Group",
							hd: false
						},
						{
							ind: 1,
							ty: "sh",
							ix: 2,
							ks: {
								a: 0,
								k: {
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											24.573,
											-27.695
										],
										[
											34.039,
											-53.476
										],
										[
											43.506,
											-27.695
										]
									],
									c: true
								},
								ix: 2
							},
							nm: "A",
							mn: "ADBE Vector Shape - Group",
							hd: false
						}
					],
					nm: "A",
					np: 5,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: false
				}
			]
		},
		fFamily: "Roobert"
	},
	{
		ch: "D",
		size: 36,
		style: "SemiBold",
		w: 68.9,
		data: {
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											23.566
										],
										[
											19.537,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											19.537,
											0
										],
										[
											0,
											-23.566
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											6.747,
											0
										],
										[
											29.608,
											0
										],
										[
											65.762,
											-35.248
										],
										[
											29.608,
											-70.496
										],
										[
											6.747,
											-70.496
										]
									],
									c: true
								},
								ix: 2
							},
							nm: "D",
							mn: "ADBE Vector Shape - Group",
							hd: false
						},
						{
							ind: 1,
							ty: "sh",
							ix: 2,
							ks: {
								a: 0,
								k: {
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-17.422
										],
										[
											12.186,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											12.186,
											0
										],
										[
											0,
											17.422
										],
										[
											0,
											0
										]
									],
									v: [
										[
											20.041,
											-11.581
										],
										[
											20.041,
											-59.015
										],
										[
											28.5,
											-59.015
										],
										[
											52.267,
											-35.248
										],
										[
											28.5,
											-11.581
										]
									],
									c: true
								},
								ix: 2
							},
							nm: "D",
							mn: "ADBE Vector Shape - Group",
							hd: false
						}
					],
					nm: "D",
					np: 5,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: false
				}
			]
		},
		fFamily: "Roobert"
	},
	{
		ch: "I",
		size: 36,
		style: "SemiBold",
		w: 26.7,
		data: {
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											6.747,
											0
										],
										[
											20.142,
											0
										],
										[
											20.142,
											-70.496
										],
										[
											6.747,
											-70.496
										]
									],
									c: true
								},
								ix: 2
							},
							nm: "I",
							mn: "ADBE Vector Shape - Group",
							hd: false
						}
					],
					nm: "I",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: false
				}
			]
		},
		fFamily: "Roobert"
	},
	{
		ch: "N",
		size: 36,
		style: "SemiBold",
		w: 71.2,
		data: {
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											6.747,
											0
										],
										[
											20.041,
											0
										],
										[
											20.041,
											-49.649
										],
										[
											50.656,
											0
										],
										[
											64.957,
											0
										],
										[
											64.957,
											-70.496
										],
										[
											51.663,
											-70.496
										],
										[
											51.663,
											-20.746
										],
										[
											21.149,
											-70.496
										],
										[
											6.747,
											-70.496
										]
									],
									c: true
								},
								ix: 2
							},
							nm: "N",
							mn: "ADBE Vector Shape - Group",
							hd: false
						}
					],
					nm: "N",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: false
				}
			]
		},
		fFamily: "Roobert"
	},
	{
		ch: "G",
		size: 36,
		style: "SemiBold",
		w: 74.1,
		data: {
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[
											-17.825,
											0
										],
										[
											-2.618,
											7.15
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											6.143,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-2.216
										],
										[
											9.567,
											0
										],
										[
											0,
											15.61
										],
										[
											-12.689,
											0
										],
										[
											-1.208,
											-7.956
										],
										[
											0,
											0
										],
										[
											17.322,
											0
										],
										[
											0,
											-24.069
										]
									],
									o: [
										[
											9.467,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-6.747
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											2.216,
											0
										],
										[
											0,
											7.553
										],
										[
											-12.488,
											0
										],
										[
											0,
											-15.61
										],
										[
											9.668,
											0
										],
										[
											0,
											0
										],
										[
											-1.108,
											-14.603
										],
										[
											-18.329,
											0
										],
										[
											0,
											24.069
										]
									],
									v: [
										[
											38.068,
											0.806
										],
										[
											57.907,
											-11.179
										],
										[
											57.907,
											0
										],
										[
											69.791,
											0
										],
										[
											69.791,
											-26.285
										],
										[
											58.109,
											-37.866
										],
										[
											39.377,
											-37.866
										],
										[
											39.377,
											-27.695
										],
										[
											53.677,
											-27.695
										],
										[
											57.303,
											-24.069
										],
										[
											38.571,
											-10.172
										],
										[
											16.415,
											-35.248
										],
										[
											38.773,
											-59.821
										],
										[
											56.598,
											-46.527
										],
										[
											69.992,
											-46.527
										],
										[
											38.873,
											-71.301
										],
										[
											3.625,
											-35.248
										]
									],
									c: true
								},
								ix: 2
							},
							nm: "G",
							mn: "ADBE Vector Shape - Group",
							hd: false
						}
					],
					nm: "G",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: false
				}
			]
		},
		fFamily: "Roobert"
	},
	{
		ch: ".",
		size: 36,
		style: "SemiBold",
		w: 27.3,
		data: {
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ind: 0,
							ty: "sh",
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									o: [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									v: [
										[
											7.05,
											-13.092
										],
										[
											7.05,
											0
										],
										[
											20.444,
											0
										],
										[
											20.444,
											-13.092
										]
									],
									c: true
								},
								ix: 2
							},
							nm: ".",
							mn: "ADBE Vector Shape - Group",
							hd: false
						}
					],
					nm: ".",
					np: 3,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: "ADBE Vector Group",
					hd: false
				}
			]
		},
		fFamily: "Roobert"
	}
];
var animationData = {
	v: v,
	fr: fr,
	ip: ip,
	op: op,
	w: w,
	h: h,
	nm: nm,
	ddd: ddd,
	assets: assets,
	fonts: fonts,
	layers: layers,
	markers: markers,
	props: props,
	chars: chars
};

export { assets, chars, ddd, animationData as default, fonts, fr, h, ip, layers, markers, nm, op, props, v, w };
//# sourceMappingURL=loader-screen-loader.json.js.map
